/**
 * StudentRealizationsScreen — « Activités faites » de l'élève, la route `realizations` ouverte par
 * « Voir plus » sous ses activités faites (adaptateur primaire, inscrit dans `routes.ts`).
 *
 * Fil : `useRealizationsData` (les pages, filtrées par la recherche — le crochet du parent, sans
 * `studentId` : l'élève lit les siennes, `getFinishedActivities`) + `studentRealizationsViewModel`
 * (la liste et la carte d'offre) + `useStudentRealizationsState` (fermer, chercher, rouvrir une
 * activité, les deux boutons de la carte) → `<RealizationsPage voice="student">`.
 */
import React from "react"
import { useSelector } from "react-redux"

import { RealizationsPage } from "../../../../../../design-system"
import { studentRealizationsViewModel } from "../../../../view-models/student/Activities/studentRealizationsViewModel"
import { useFinishedActivitiesParams } from "../../../hooks/useFinishedActivitiesParams"
import { useRealizationsData } from "../../parent/Activities/useRealizationsData"
import { StudentOfferSlot } from "./StudentOfferSlot"
import { useStudentRealizationsState } from "./useStudentRealizationsState"

export function StudentRealizationsScreen() {
    const { search, actions } = useStudentRealizationsState()
    const { refresh, loadMore, hasMore } = useRealizationsData(null, useFinishedActivitiesParams(search))
    const vm = useSelector(studentRealizationsViewModel)

    return (
        <RealizationsPage
            voice="student"
            activities={vm.activities}
            search={search}
            onSearchChange={actions.setSearch}
            searchSubjects={vm.searchSubjects}
            searchResultCount={vm.total}
            loading={vm.loading}
            loadingMore={vm.loadingMore}
            hasMore={hasMore}
            error={vm.error}
            onRetry={refresh}
            onLoadMore={loadMore}
            onClose={actions.close}
            onOpenActivity={actions.openActivity}
            topSlot={
                vm.offer != null ? (
                    <StudentOfferSlot
                        offer={vm.offer}
                        onStartTrial={actions.startTrial}
                        onAskQuestion={actions.askQuestion}
                    />
                ) : undefined
            }
        />
    )
}
